import {
  EditingArticle_editingArticle,
  EditingArticle_editingArticle_checkInLocation,
} from '@apollo-types/EditingArticle'

export type LocationData = EditingArticle_editingArticle_checkInLocation & {
  updatedTime?: number
}

export enum AutosaveStatusType {
  'IDLE' = 'IDLE',
  'PENDING' = 'PENDING',
  'SUCCEEDED' = 'SUCCEEDED',
  'FAILED' = 'FAILED',
}

export enum PublishButtonStatusType {
  /**
   * 閒置中；可以按下發佈按鈕
   */
  'IDLE' = 'IDLE',

  /**
   * 禁用中；不能按下發佈按鈕
   */
  'DISABLED' = 'DISABLED',

  /**
   * 載入中
   */
  'LOADING' = 'LOADING',
}

export enum Warning {
  imageRequired = 'imageRequired',
  contentRequired = 'contentRequired',
  categoryRequired = 'categoryRequired',
  titleRequired = 'titleRequired',
  titleLengthLimited = 'titleLengthLimited',
}

export interface ArticleState extends Partial<EditingArticle_editingArticle> {
  imageIds: string[]
  categoryIds: string[]
  categoryId: string
  checkInLocationId: string
  checkInLocation: LocationData
  coverImageId: string
  ogTitle: string
  ogDescription: string
  ogImageId: string
  isInitialData: boolean
  autosaveStatus: AutosaveStatusType
  publish: {
    status: PublishButtonStatusType
    /**
     * 發佈按鈕狀態變動的觸發來源
     */
    actionTarget?: 'upload_content_image' | 'upload_cover_image'
    timestamp?: number
    warnings?: Partial<Record<Warning, boolean>>
    action?: string
  }
  scheduledAt: string
}
